import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Tickets from './Views/Tickets.jsx';
import Login from './Views/Login.jsx';
import DetailsTickets from './Views/Details.jsx';
import Help from './Views/Help.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import { useAuth } from './context/AuthContext.js';

function AppRoutes() {
  const location = useLocation();
  const { isConnected, loading } = useAuth();

  const loginElement = !loading && isConnected
    ? <Navigate to="/tickets" replace />
    : <Login />;

  return (
    <Routes>
      <Route path="/" element={loginElement} />
      <Route path="/login" element={loginElement} />
      <Route
        path="/tickets"
        element={
          <ProtectedRoute key={location.pathname}>
            <Tickets />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ticket/:ticketId"
        element={
          <ProtectedRoute key={location.pathname}>
            <DetailsTickets />
          </ProtectedRoute>
        }
      />
      <Route
        path="/aide"
        element={
          <ProtectedRoute key={location.pathname}>
            <Help />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default AppRoutes;
